import { render, staticRenderFns } from "./WithManualPagination.vue?vue&type=template&id=25e07f45"
import script from "./WithManualPagination.vue?vue&type=script&lang=js"
export * from "./WithManualPagination.vue?vue&type=script&lang=js"
import style0 from "./WithManualPagination.vue?vue&type=style&index=0&id=25e07f45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports